<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3 class="wizard-title" style="color: green">Almost Done!</h3>

      <h5>
        You have completed the preliminary Registration. Please press FINISH below to submit. We will send a
        confirmation and login instructions to your email within 2 days.
      </h5>
      <h5>
        If you do not receive notification from GlobeChek within 2 days, please contact us at
        <a href="mailto:info@globechek.com">Info@GlobeChek.com</a>
      </h5>
      <h5>Thank you for registering with GlobeChek!</h5>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      //
    }
  },
  watch: {},
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    }
  }
}
</script>
<style></style>
